const PostsAPILink = `http://localhost:81/wp-json/wp/v2/`;

export {PostsAPILink};